export default __webpack_public_path__ + "static/media/WHERE_TO.6af2e356.png";